// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../.yarn/__virtual__/css-loader-virtual-28ab7c4aeb/0/cache/css-loader-npm-6.11.0-d945f9f4c0-5c8d35975a.zip/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../.yarn/__virtual__/css-loader-virtual-28ab7c4aeb/0/cache/css-loader-npm-6.11.0-d945f9f4c0-5c8d35975a.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* @import \"./new_issue_modal.scss\"; */", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
